import { useState, useEffect } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";
import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { useTranslation } from "react-i18next";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";



interface PodImageAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};


PodImageAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}



export default function PodImageAdd(props:PodImageAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);

    const [podImageName, setPodImageName] = useState("");
    const [podImageDesc, setPodImageDesc] = useState("");
    const [podImageVersion, setPodImageVersion] = useState("latest");
    const [podImagePath, setPodImagePath] = useState("");
    const [registryId, setRegistryId] = useState("");
    const [projectId, setProjectId] = useState("");

    const [registryList, setRegistryList] = useState<DropdownType[]>([]);
    const [projectList, setProjectList] = useState<DropdownType[]>([]);

    const [podImageNameWarnYn, setPodImageNameWarnYn] = useState(false);

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(stepIndex === 0) {
            loadProjectList();
        }
    }, [stepIndex])


    useEffect(()=> {
        if(projectId) {
            loadRegistryList();
        }
    }, [projectId]);

    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {

                }
            } else {
                const successYn = checkPodImageData();
                if(successYn) {
                    setExecuteAddYn(true);
                }
            }
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(executeAddYn) {
            executeAddPodImage();
        }
    }, [executeAddYn]);

    function loadRegistryList() {
        requests.get(PLATFORM_URL.PROJECT + '/' + projectId + PLATFORM_URL.REGISTRY, {size: 9999})
        .then((response) => {
            setRegistryList(response.data.items?.map((data, index) => {
                return {
                    value: data.registry_id,
                    label: data.registry_name };
            }));
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function loadProjectList() {
        requests.get(PLATFORM_URL.PROJECT, {size: 9999})
        .then((response) => {
            setProjectList(response.data.items.map((v) => {
                return {
                    value: v.project_id,
                    label: v.project_name
                }
            }));
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function checkPodImageData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }

        setPodImageNameWarnYn(false);
        let message = "";
        let error = false;
        if(!podImageName || !projectId || !registryId) {
            message = t("MESSAGE_POD_IMAGE_INFO_ENTER_ERROR_MESSAGE")
            error = true;
            if(!podImageName) {
                setPodImageNameWarnYn(true);
            }
        }
        if(error == true) {
            executeResult({}, false, message);
        }

        return !error;
    }


    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function executeAddPodImage() {
        const body = {
            container_image: {
                container_image_name: podImageName,
                container_image_description: podImageDesc,
                container_image_version: podImageVersion,
                pull_path: podImagePath,
                insecure_yn: true
            },
            registry: {
                registry_id: registryId
            },
            project: {
                project_id: projectId
            }
        }

        requests.post(PLATFORM_URL.POD_IMAGE, body)
        .then((response) => {
            executeResult({successYn: true }, true, "");
        })
        .catch((error) => {
            if(error.status === 409) {
                setPodImageNameWarnYn(true);
                executeResult({successYn: false}, false, t("MESSAGE_POD_IMAGE_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }

    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("POD_IMAGE_CREATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("NAME_TEXT")}
                            </Text>
                            <CustomTextInput
                                key={1}
                                width={560} height={36}
                                value={podImageName}
                                type={"text"}
                                activeYn={true}
                                inputCb={setPodImageName}
                                warnYn={podImageNameWarnYn}
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea
                                key={2}
                                width={570} height={100}
                                value={podImageDesc}
                                type={"text"}
                                activeYn={true}
                                inputCb={setPodImageDesc}
                                warnYn={false}
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={style.titleText}>{
                        t("DETAIL_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("IMAGE_VERSION_TEXT")}
                            </Text>
                            <CustomTextInput
                                key={3}
                                width={560} height={36}
                                value={podImageVersion}
                                type={"text"}
                                activeYn={true}
                                inputCb={setPodImageVersion}
                                warnYn={false}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("POD_IMAGE_PULL_ENDPOINT_TEXT")}
                            </Text>
                            <CustomTextInput
                                key={4}
                                width={560} height={36}
                                value={podImagePath}
                                type={"text"}
                                activeYn={true}
                                inputCb={setPodImagePath}
                                warnYn={false}
                            />
                        </View>
                    </View>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("PROJECT_SELECT_TEXT")}
                            </Text>
                            <CustomDropDown
                                key={3}
                                width={400} height={36}
                                items={projectList}
                                value={projectId}
                                setValue={setProjectId}
                                disable={false}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View>
                    </View>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("REGISTRY_SELECT_TEXT")}
                            </Text>
                            <CustomDropDown
                                key={4}
                                width={400} height={36}
                                items={registryList}
                                value={registryId}
                                setValue={setRegistryId}
                                disable={projectId ? false : true}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    requireText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#e86045"
    },
    infoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    }
});